import { createFileRoute, Outlet } from '@tanstack/react-router';
import Journeys from '@/pages/journeys';
import { AccountFeatureFlag, useFeatureFlag } from '@/services/auth/feature-flags';

export function CollectionDetailRoute() {
  const isHydraCollections = useFeatureFlag(AccountFeatureFlag.CollectionsInHydra);

  if (!isHydraCollections) {
    return <Journeys />;
  }

  return <Outlet />;
}

export const Route = createFileRoute('/_authenticated/workspaces/$workspaceId/journeys/collections/$collectionId')({
  component: CollectionDetailRoute,
});
